var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCat1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#020202;stroke-miterlimit:10;stroke-width:1.91px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "drug"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.34,
    y: 0.3,
    width: 6.74,
    height: 14.83,
    rx: 3.37,
    transform: "translate(7.71 -3.19) rotate(45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 16.76,
    cy: 16.76,
    r: 5.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 20.77,
    y1: 20.77,
    x2: 12.95,
    y2: 12.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 10.09,
    y1: 10.09,
    x2: 5.33,
    y2: 5.33
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCat1);
export default __webpack_public_path__ + "static/media/cat1.6a7108250b1ee9680650294771582cdc.svg";
export { ForwardRef as ReactComponent };